var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgmailbox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 574.55,
    height: 570.24,
    viewBox: "0 0 574.55 570.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.43,
    y: 181.81,
    width: 158.18,
    height: 35.41,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 195.78,
    y: 238.81,
    width: 168,
    height: 167,
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M232.52,561.33c96,24.23,196.43-9.66,254.32-68.68s79.9-138.23,85.37-216.93c3.24-45.81,1.58-93.18-16.41-138.86C537.78,91.48,501.38,47.64,450.22,23c-83-39.46-183.46-20.92-258,16.44C147.22,62,107.57,90.82,74.91,124.62,23,179.08-98.25,436.65,161.72,543.18",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "square",
      strokeWidth: 2,
      opacity: 0.07999999821186066,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.09,520.07c72.69,24.35,152.26,4.09,200.44-38.09s69.83-102,78.69-162.5c5.19-35.19,6.7-71.87-4.51-108.2-11.24-36.11-36.78-72.11-74.83-94.12C374.09,81.8,295.43,90.21,235.7,114.69c-36.12,14.73-68.43,34.66-95.65,58.84C96.74,212.54-12,404.32,182.47,501.89",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "square",
      strokeWidth: 2,
      opacity: 0.07999999821186066,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.91,442.74c47.75,25.5,105.53,20.75,144-2.95S428.55,377,441.82,335.91c7.76-23.89,13.12-49.25,9.58-75.86-3.58-26.46-17.13-54.52-41-74.32-38.86-31.88-94.61-35.28-139.07-25.26a235,235,0,0,0-73.51,29.73c-34.74,22.06-133,142.79-9.06,233.58",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "square",
      strokeWidth: 2,
      opacity: 0.07999999821186066,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.35,206.46c.72-.61,3.44-.47,3.52,1.15s3.46,23.41,2.94,24S8.75,235.82,8,234.55c-.21-.35-3.28-2.46-.37-5.76C14.88,220.54,33.35,206.46,33.35,206.46Z",
    style: {
      fill: "#38445e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75,209.2q14.37-1.87,28.74-3.67a2.49,2.49,0,0,1,1.48.14,2.17,2.17,0,0,1,.66,1.57c1.08,7.58,2.18,15.22,3.32,22.78a227.88,227.88,0,0,0-30.73,4.16A1.8,1.8,0,0,1,5.74,234a1.31,1.31,0,0,1-.36-.77A123.5,123.5,0,0,1,2.69,211",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.57,209.89l25.61-3.27c.64-.07,2.69-.63,3.13-.4,1.39.69,1.9,3.08,2.12,4.41q.47,3.13.94,6.29c.62,4.46,1.29,8.85,1.9,13.31.26-.32.6-.59.86-.91a243.94,243.94,0,0,0-25.43,3.17c-2,.35-5.55,1.7-6.69-.29s-1-5.55-1.4-7.83c-.63-4.53-1-9.1-1.19-13.66,0-.92-1.45-.35-1.48.45A122.76,122.76,0,0,0,3.46,227.3c.37,2.35.15,7.51,3.14,7.66,2.38.09,5.42-1,7.71-1.37,2.47-.39,4.88-.77,7.37-1.1,5.35-.75,10.68-1.29,16-1.64.39,0,1-.46.86-.9-.79-5.28-1.52-10.57-2.3-15.78-.36-2.35.13-8.36-2.8-9.18-1.6-.45-4.3.45-6,.67-2.49.33-5,.66-7.48.93L3.83,208.66C3.17,208.6,2.62,210,3.57,209.89Z",
    style: {
      fill: "#38445e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.41,210.92c3.92,2.06,7.88,4,11.79,6.1,2.28,1.15,5.8,4.15,8.48,3.45,2.17-.59,4.61-3.28,6.18-4.86a38.84,38.84,0,0,0,6.42-8.71c.53-.9-.67-1.3-1.15-.47A37.93,37.93,0,0,1,28.72,214c-2,2.2-4.85,5.62-8.08,4.6-2.88-.89-5.75-3-8.41-4.38-3-1.52-6-3.13-9-4.65C2.58,209.25,1.68,210.56,2.41,210.92Z",
    style: {
      fill: "#38445e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.64,208.22s-7.34,10.87-8.54,12S22,220,22,220a65.85,65.85,0,0,0,5.86-4.2c1.09-1.08,6.4-8.18,6.4-8.18Z",
    style: {
      fill: "#38445e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.17,194.93c63-7.12,147.51,40.54,154.63,103.54s-48.05,115.66-111,122.77a114.9,114.9,0,0,1-127-101.3C165.69,256.87,193.24,202.05,256.17,194.93Z",
    style: {
      fill: "#51b36d"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#a)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M293.24,212.88c32.38,2.43,64.77-.34,97.16.87,14.48.52,29,2.78,43.29,1.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.07,214.62c23,1.56,46.19.87,69.37.52,23.86-.17,48.07,3.47,71.93,1.39,2.73-.17,1.53-3.47-.85-3.3-22.67,2.08-45.85-1.56-68.52-1.39-23.86.18-47.73,1.22-71.59-.52C290.68,211.15,290.34,214.45,293.07,214.62Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.56,213.06c-10.22,0-21.64-.52-28.63-8-4.43-4.86-6.31-11.8-10.4-17a11.33,11.33,0,0,0-6.65-4.69c-2.55-.52-5.11.52-7.32,1.74a21.15,21.15,0,0,0-8.19,9.55c-1.53,3.64-2.89,8.33-7,8.33a7.81,7.81,0,0,1-2.73-.7c-4.77-2.6-7.67-7.81-13-9.89a10.18,10.18,0,0,0-5.11-.69c-6,1.21-5.79,8-9.54,11.28-2.05,1.73-4.95,2.26-7.67,2.6-15.69,1.91-31.37,3.47-47.22,4.52-1,0-1,1.56,0,1.73a148.89,148.89,0,0,0,19.6,1.56",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.56,211.49c-10.05,0-21.64-.34-28.46-9.2-4.26-5.72-6-14.06-12.1-18.4-4.27-2.95-9.21-2.43-13.64,0a22.34,22.34,0,0,0-6.31,5.73,27.3,27.3,0,0,0-2.72,4.86c-1.71,3.3-1,4.86-5.29,5.21-6.3.52-10.57-8.85-17.55-9.55-5.63-.52-7.84,2.43-10.74,6.6-6.82,10.07-23.52,8.85-34.6,9.89-5.63.53-11.25,1.05-16.88,1.39-2.9.18-5.28-.34-7.33,1.74-.51.52-.85,1.39-.17,1.91,3.75,4.69,16.71,3,22.16,3.12,2.73,0,2.39-3.12-.17-3.3-1.36,0-15.51-1.56-16-.34.34-1,15.51-1.22,16.87-1.39,9.72-.87,21-.7,30.17-3.3,2.9-.87,5.12-1.74,7.16-4,1.71-2.09,2.05-5.21,3.92-7.12,8-8,15.51,8.85,23.18,9,4.26,0,6.31-3.3,8-6.77,3.24-5.9,9.72-17.71,18.41-9.9,3.75,3.3,5.46,8.68,7.84,12.85,7.5,12.84,21,14.06,34.43,14.06C438.46,214.62,438.12,211.49,435.56,211.49Z",
    style: {
      fill: "#1a2e44"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M333.93,401.53c0,2.21-12.29,4-27.49,4-7.18,0-16.72.69-21.55,0-5.39-.69-5.81-2.89-5.81-4,0-2.21,23.49-3.59,38.69-3.59S333.93,399.32,333.93,401.53Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,340.53c4.15,0,7.46.27,7.33.69-.83,2.21-16.31,31.19-17.69,34.23-1,2.2-18.65,19.18-34.68,19.18h-6.9c-16.17.14-16.31-18.49-15.48-20.7,1.11-3.31,15.2-30.78,15.48-32.16.13-.41,3.17-.83,7.18-.83C230.73,340.67,251.45,340.53,265,340.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,342.18c1.52,0,5.25-.41,6.63.56-.13-.69-.27-1.52-.41-2.21-4,10.21-10.22,19.74-15.2,29.4-5.94,11.59-19.34,20.84-32.33,22.77-5.66.83-14.23,1.24-18.92-2.21-4.29-3.17-7.19-10.49-5.95-15.87,1-4.28,4.15-8.83,6.08-12.7,2.77-5.66,5.67-11.18,8.29-16.84,1.38-2.9.83-2.48,3.87-2.2,4.7.27,9.53-.28,14.23-.28,11.19-.28,22.38-.28,33.71-.42,1.66,0,1.94-3.45.14-3.45-11.6,0-23.21.14-34.68.28-5.11,0-15.47-1.93-18.65,2.62-3.59,5.25-5.94,12.15-8.84,17.95-2.21,4.55-5.8,9.66-6.77,14.76a18.25,18.25,0,0,0,18,22c14.92.14,31.91-6.63,41-19.05,3.46-4.69,5.67-10.76,8.29-15.87,3.32-6.35,7.46-12.7,9.95-19.46.28-.69.41-1.8-.41-2.21-1.8-1.24-5.95-.83-8-.83C263.47,338.87,263.06,342.18,265,342.18Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.43,341.08c.28,12.42,1.25,48,1.66,57,0,1.93-.69,3.17-1.38,3.59-2.63,1.24-8.7,1.38-11.47-.55a4.08,4.08,0,0,1-1.79-3.32c-.42-14.63-1.11-44.57-1.39-57",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.19,340.8c.28,9.39.55,18.64.83,28q.21,8.07.41,16.15c.14,3.59,1,8.14.42,11.59-.69,3.87-4.7,5.66-8.57,3.87s-3.45-5.94-3.59-9.39c-.14-5.93-.28-11.73-.41-17.66-.28-10.63-.56-21.53-.83-32.44,0-1.93-2.63-2.62-2.63-.27.28,14.07.69,28.15,1,42.23.14,5-1.11,12.56.83,17.11s8.15,4.83,12.29,3.87,4.42-3.87,4.42-7.87c0-5.52-.27-10.9-.41-16.42-.41-12.84-.69-25.67-1.11-38.51C303.68,339.29,301.05,338.6,301.19,340.8Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.31,341.36c13.68,0,79-.14,86.49-.83,4-.28,7-2.9,7-5.8-.14-9.94,0-41.27,0-65.14a29.32,29.32,0,0,0-29.29-29.4H249",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.17,342.74c21.14,0,42.14-.14,63.28-.28,7.46-.14,15.47.55,22.93-.41,11.74-1.52,8.84-13.25,8.84-22.09,0-16.14.14-32.15.14-48.3,0-13-5.94-24.57-18.24-30.09C339.05,239,332.83,239,326.33,239H300.78c-17-.14-34.41-.14-51.81-.14-1.94,0-2.35,2.76,0,2.76,27.49,0,55.12-.55,82.61,0,12.3.28,23.35,7.45,27.22,19.32,2.21,6.9,1.38,14.63,1.38,21.67v42.51c0,5.94,1.52,12.15-5.94,14.22-6.35,1.65-14.78.27-21.14.41-21.55.28-43.1.28-64.79.28C266.37,340,266,342.74,268.17,342.74Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.27,341.36a91.93,91.93,0,0,1,9,5C297.6,348.12,303,349,303,349v-7.59Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,261.24q16-.21,31.92,0c1.93,0,4,.14,5.94.14,1.1,0,2.35.41,1.93,0a54,54,0,0,0-.41,6.07q0,4.56-.42,9.11c-.14,1.66,3.32,1.66,3.46-.14q.4-5,.41-9.93c0-1.25.55-5.11-.27-6.35-1.11-1.8-3.32-1.24-5.39-1.38q-18.66-.42-37.31,0C295.8,258.76,295.94,261.24,298,261.24Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.61,260.69c0,4.83-.55,10.35.28,15,.83,4.28,7.18,1,9.94,1.52,1.66.28,3-2.9,1.25-3.17a16.63,16.63,0,0,0-5.25.41c-.69.14-2.49.55-3,.14,0,0,.14.41,0-.28-.14-.27,0-.82,0-1.1-.14-4.55-.28-9-.28-13.53C329.51,257.52,326.61,259,326.61,260.69Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.57,341.36c-4.28,0-7.46-2.21-7.46-5,.14-16.43.55-45.41.83-67.35a29.24,29.24,0,0,1,29.43-28.85h6.91a29.5,29.5,0,0,1,29.29,29.4c-.14,23.87-.14,55.2,0,65.14,0,2.9-3,5.52-7.05,5.8C260,341.36,232,341.36,218.57,341.36Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.12,340c-7.87-.69-6.49-7-6.49-12.56,0-4.7.14-9.53.14-14.22q.21-16.35.41-32.71c.14-11-.27-21.81,7.88-30.36,6.91-7.18,15.47-8.56,24.73-8.56,9.67.14,18.65,3.45,24.59,11.59s5.53,17.81,5.39,27.61c0,10.35-.14,20.84-.14,31.19,0,6.76,1.38,15.18,0,21.81-1.8,8.69-21.83,5.93-28,5.93q-14.51.21-29,0c-1.79,0-2.76,2.76-.55,2.76,11.33,0,22.52,0,33.85-.14,6.77-.14,19.06,1.8,24.59-3.17,4.84-4.42,2.35-15.87,2.35-21.67,0-13,0-26,.14-39.06,0-11.18,0-21.53-8.15-30.22-6.64-7-15.2-9.53-24.6-9.67-18.79,0-35.09,10.77-35.92,30.92-.69,15.6-.55,31.19-.69,46.79-.14,6.35-.41,12.69-.14,19,.28,5.25,3.46,7,8.43,7.46C219.54,342.87,221.33,340.11,219.12,340Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.2,403.19c-2.62-6.9-3.87-15.18-8.15-21.26-.27-.41-1.52-.41-1.24.42,2.9,7,5.39,14.21,5.52,21.8a5.57,5.57,0,0,0,1.39-.13,53.27,53.27,0,0,1-4.15-9c-.14-.56-1.52-.56-1.38.13a53.75,53.75,0,0,1,1.52,8.15,3.19,3.19,0,0,1,1.11-.28,31.55,31.55,0,0,1-5.95-6.9c-.41-.55-1.65-.28-1.1.41a38.21,38.21,0,0,0,6.08,7.18c.27.28,1.24.28,1.1-.28a55.44,55.44,0,0,0-1.52-8.14,5.11,5.11,0,0,0-1.38.14,53.27,53.27,0,0,0,4.15,9c.27.41,1.38.69,1.38-.14-.14-7.86-2.63-14.9-5.53-22.08l-1.24.41c4.28,5.94,5.52,14.22,8,21C287.1,404,288.48,403.88,288.2,403.19Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.35,400.84c1.79-5,2.76-11.18,5.94-15.59l-1.24-.42c-2.22,5.38-4,10.63-4.15,16.43,0,.55,1,.69,1.24.27a42.4,42.4,0,0,0,3.18-6.76,4,4,0,0,0-1.38-.28,29.92,29.92,0,0,0-1.11,6.08.79.79,0,0,0,1.25.55,21.74,21.74,0,0,0,4.56-5.38c.41-.56-.83-1.11-1.25-.56a21.92,21.92,0,0,1-4.42,5.11c.42.14.83.41,1.25.55a46.09,46.09,0,0,1,1.1-6.07c.14-.69-1.1-1-1.38-.28a35,35,0,0,1-3,6.49,4,4,0,0,0,1.24.28c.14-5.66,1.94-10.91,4.15-16.15.28-.55-1-1-1.24-.42-3.18,4.56-4.15,10.63-6.08,15.88C311.83,401.12,313.07,401.39,313.35,400.84Z",
    style: {
      fill: "#1a2e44"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M301.59,305.59,299,307.12a.41.41,0,0,0,0,.71l10.05,5.63a2,2,0,0,0,1.92,0l10.17-5.7a.38.38,0,0,0,0-.68l-2.73-1.48a1.11,1.11,0,0,0-.93,0L311,309.27a2,2,0,0,1-1.92,0l-6.58-3.68A.94.94,0,0,0,301.59,305.59Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.05,283.48a2,2,0,0,1,1.92,0l8.09,4.53a.44.44,0,0,1,0,.8l-1.5.83a3,3,0,0,1-2.93,0L311,287.58a2,2,0,0,0-1.92,0l-3.68,2.06a3,3,0,0,1-2.92,0l-1.56-.87a.39.39,0,0,1,0-.73Z",
    style: {
      fill: "#1a2e44"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.67,290.3a1.86,1.86,0,0,1,1,1.61V305c0,.64-.41.77-.84.54l-3-1.62v-8.81L311,300.08a2,2,0,0,1-1.92,0l-8.83-4.94V304l-2.72,1.62c-.32.2-1.11.27-1.11-.54V291.91a1.84,1.84,0,0,1,1-1.61,2.29,2.29,0,0,1,1.94,0l10.72,6,10.7-6A2.05,2.05,0,0,1,322.67,290.3Z",
    style: {
      fill: "#51b36d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.16,259.22c.83-.44,3.46.28,3.19,1.88s-1.66,23.61-2.31,24.12-31.23-2.62-31.73-4c-.13-.39-2.67-3.1.88-5.7C521.1,269,542.16,259.22,542.16,259.22Z",
    style: {
      fill: "#38445e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.67,255.52q14.42,1.28,28.85,2.6a2.45,2.45,0,0,1,1.41.47,2.15,2.15,0,0,1,.31,1.67c-.58,7.63-1.15,15.32-1.66,23a227.39,227.39,0,0,0-30.91-2.56,1.79,1.79,0,0,1-1.41-.46,1.34,1.34,0,0,1-.18-.83,124.13,124.13,0,0,1,2.16-22.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.34,256.16l25.71,2.32c.65.07,2.76,0,3.15.28,1.21,1,1.19,3.41,1.11,4.76-.14,2.12-.29,4.23-.43,6.35-.36,4.49-.65,8.91-1,13.4.32-.25.7-.44,1-.69a242.79,242.79,0,0,0-25.52-2.39c-2-.08-5.78.47-6.47-1.72s.17-5.64.32-8c.35-4.55,1-9.1,1.77-13.59.2-.9-1.34-.65-1.54.12a124.49,124.49,0,0,0-2,16.09c-.14,2.37-1.47,7.37,1.42,8.16,2.3.59,5.51.17,7.82.32,2.5.14,4.94.29,7.44.5,5.39.43,10.71,1.05,16,1.86.38.07,1-.25,1-.7.37-5.32.79-10.64,1.15-15.9.15-2.37,1.93-8.14-.75-9.57-1.47-.78-4.3-.48-6-.62-2.5-.21-5-.43-7.5-.7L512.86,255C512.22,254.81,511.38,256.09,512.34,256.16Z",
    style: {
      fill: "#38445e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511,256.92c3.38,2.85,6.82,5.64,10.2,8.49,2,1.62,4.77,5.3,7.53,5.19,2.25-.11,5.21-2.2,7.08-3.41a38.9,38.9,0,0,0,8.15-7.12c.71-.77-.38-1.42-1-.72a38,38,0,0,1-6.92,6.24c-2.45,1.71-5.94,4.44-8.88,2.75-2.62-1.49-5-4.14-7.26-6.09-2.62-2.13-5.17-4.34-7.78-6.47C511.51,255.32,510.35,256.4,511,256.92Z",
    style: {
      fill: "#38445e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543,261.22s-9.51,9-10.92,9.86-4-1.13-4-1.13a68.25,68.25,0,0,0,6.63-2.83c1.29-.83,8-6.61,8-6.61Z",
    style: {
      fill: "#38445e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.47,300.19c1.08-.43,4.19.82,3.64,2.74S88.88,331.52,88,332.06s-37.78-7.44-38.2-9.24c-.1-.49-2.84-4.15,1.85-6.85C63.42,309.28,90.47,300.19,90.47,300.19Z",
    style: {
      fill: "#38445e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,291.67c11.63,2.34,23.26,4.68,34.88,7.1a3,3,0,0,1,1.66.75,2.67,2.67,0,0,1,.15,2.08c-1.74,9.25-3.48,18.57-5.14,27.82a278.27,278.27,0,0,0-37.4-7.32,2.19,2.19,0,0,1-1.66-.75,1.61,1.61,0,0,1-.11-1.05A151.35,151.35,0,0,1,53,293.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.47,292.41l31.09,6.32c.77.18,3.38.33,3.8.77,1.35,1.36,1,4.33.72,6-.47,2.56-.93,5.13-1.4,7.69-1,5.43-2,10.8-3,16.23.43-.26.92-.44,1.35-.71a297.48,297.48,0,0,0-30.84-6.37c-2.42-.37-7.12-.22-7.66-3s1-6.87,1.47-9.67c1-5.51,2.42-11,4-16.36.37-1.07-1.55-1-1.9-.07a152.6,152.6,0,0,0-4.61,19.39c-.5,2.87-2.8,8.79.62,10.15,2.73,1,6.71,1,9.51,1.45,3,.52,6,1,9,1.63,6.52,1.26,12.93,2.74,19.32,4.45.46.13,1.29-.16,1.35-.71,1.17-6.45,2.41-12.9,3.57-19.27.5-2.88,3.45-9.67.37-11.79C89.53,297.38,86,297.36,84,297c-3-.6-6-1.19-9.06-1.87l-19.69-4C54.51,290.75,53.31,292.19,54.47,292.41Z",
    style: {
      fill: "#38445e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.72,293.15c3.74,3.94,7.56,7.81,11.3,11.75,2.2,2.25,5.11,7.12,8.49,7.37,2.76.17,6.67-2,9.12-3.21a47.85,47.85,0,0,0,10.91-7.59c1-.84-.27-1.78-1.15-1a46.19,46.19,0,0,1-9.29,6.68c-3.23,1.76-7.86,4.62-11.22,2.15-3-2.18-5.51-5.74-8-8.42-2.9-3-5.71-6-8.61-9C53.58,291.27,52,292.43,52.72,293.15Z",
    style: {
      fill: "#38445e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.27,302.75S78.44,312.5,76.6,313.31s-4.7-1.91-4.7-1.91a83.39,83.39,0,0,0,8.49-2.56c1.68-.83,10.67-7,10.67-7Z",
    style: {
      fill: "#1a2e44"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgmailbox);
export default __webpack_public_path__ + "static/media/imgmailbox.a6698bb34eef13206ac5196bb6fe4e06.svg";
export { ForwardRef as ReactComponent };